import Permisos from '@/router/permisos'

const DefaultContainer = () => import('@/layouts/DefaultLayout.vue')
const ViewUnidadMedida = () => import('./Index')

const router = [
  {
    path: '/',
    component: DefaultContainer,
    children: [
      {
        path: 'unidad_medida',
        name: 'Unidad de Medida',
        component: ViewUnidadMedida,
        beforeEnter: Permisos.IS_AUTENTICADO,
      },
    ],
  },
]

export default router
